import axios from 'axios'
import React, { useEffect, useState } from 'react'
import FilterListIcon from '@mui/icons-material/FilterList';
import MenuIcon from '@mui/icons-material/Menu';
import ClearIcon from '@mui/icons-material/Clear';
import Modal from 'react-bootstrap/Modal';
import Offcanvas from 'react-bootstrap/Offcanvas';
import dayjs from 'dayjs';
import DocViewer, { DocViewerRenderers, PDFRenderer, PNGRenderer } from "react-doc-viewer";
import PDFViewer from './PDFViewer';
import Spinner from 'react-bootstrap/Spinner';
import Pagination from 'react-bootstrap/Pagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import CustomSpinner from '../components/CustomSpinner';
function YesFamily({ serverURL, user, setShowSideOverlay }) {
    const finder = "YG Head Count Form"
    const [allEntries, setAllEntries] = useState([])
    const [loadingEntries, setLoadingEntries] = useState(true);

    const [searchFilters, setSearchFilters] = useState([]);
    const [formId, setFormId] = useState(null)
    const [filterState, setFilterState] = useState(false)
    const [currentYGEditData, setCurrentYGEditData] = useState(null)
    const [showEditYGDetails, setShowEditYGDetails] = useState(false)

    const [puchLiyaBhai, setPuchLiyaBhai] = useState(false)
    const [puchLiyaBhaiSaveKeLiye, setPuchLiyaBhaiSaveKeLiye] = useState(false)

    const [formStructure, setFormStructure] = useState(null)

    const [viewFormContent, setViewFormContent] = useState(null)
    const [showFileUpdateModal, setShowFileUpdateModal] = useState(false)
    const [updatedFileSelection, setUpdatedFileSelection] = useState(null)
    const [fieFieldUpdate, setFieFieldUpdate] = useState("")

    const [entriesLimit, setEntriesLimit] = useState(20)
    const [skipEntries, setSkipEntries] = useState(0)

    const [totalEntriesCount, setTotalEntriesCount] = useState(0)

    const onlyAllowed = [
        "Employee Code",
        "Employee Name",
        "Official Mail Id",
        "Process / Department",
        "Sub Department",
        "Designation",
        "Location",
        "Reporting Manager's Email ID",
        "Company Name"
    ]

    const getAllForms = async () => {
        setLoadingEntries(true);
        const getAllForms = await axios.post(serverURL + "/forms/getAll")

        if (getAllForms.status === 200) {
            const allForms = getAllForms.data;
            if (allForms.length > 0) {
                const YGHEADCOUNTFORM = allForms.filter((form) => { return form.name === finder })[0]._id;

                setFormId(YGHEADCOUNTFORM)

                const getAllEntries = await axios.post(serverURL + "/forms/countEntries", { "formRefId": YGHEADCOUNTFORM })
                if (getAllEntries.status === 200) {
                    // console.log(getAllEntries.data)
                    setTotalEntriesCount(getAllEntries.data)
                } else {
                    console.log(getAllEntries.data)
                }
            } else {
                setAllEntries([])
            }
            setLoadingEntries(false)
        }
        else {
            console.log(getAllForms.data)
            setLoadingEntries(false)
        }
    }

    const addFilters = async (naamkaran, value) => {
        let finalSearcher = {}

        if (value.length > 0) {
            if (!searchFilters.includes(naamkaran)) {
                setSearchFilters([...searchFilters, naamkaran]);
                // console.log("Searching with:" + value)

                let top = [...searchFilters, naamkaran].map((data, key) => {
                    const getTheField = document.getElementById(`filter_${data}`)
                    return finalSearcher[`${data}`] = getTheField.value
                })

                // console.log(finalSearcher)
            } else {
                let top = [...searchFilters, naamkaran].map((data, key) => {
                    const getTheField = document.getElementById(`filter_${data}`)
                    return finalSearcher[`${data}`] = getTheField.value
                })

                // console.log(finalSearcher)
            }
        } else {
            if (searchFilters.includes(naamkaran)) {
                setSearchFilters(searchFilters.filter((filter) => { return filter !== naamkaran }))

                searchFilters.filter((filter) => { return filter !== naamkaran }).map((data, key) => {
                    const getTheField = document.getElementById(`filter_${data}`)
                    return finalSearcher[`${data}`] = getTheField.value
                })

                // console.log(finalSearcher)
            } else {
                searchFilters.filter((filter) => { return filter !== naamkaran }).map((data, key) => {
                    const getTheField = document.getElementById(`filter_${data}`)
                    return finalSearcher[`${data}`] = getTheField.value
                })

                // console.log(finalSearcher)
            }
        }

        let FinalFilterFormat = {};
        FinalFilterFormat["formRefId"] = formId

        Object.keys(finalSearcher).map((done, key) => {
            return FinalFilterFormat[`submittedData.${done}`] = { '$regex': `${finalSearcher[done].trim()}`, '$options': "i" }
        })

        console.log(FinalFilterFormat)

        // [
        //     { "submittedData": { "$elemMatch": { 'Employee Code': { '$regex': 'SS0001' } } } },
        //     { "submittedData": { "$elemMatch": { 'Employee Name': { '$regex': 'Sachin' } } } }
        // ]

        const getALlEntriesWithFilter = await axios.post(serverURL + "/forms/getEntriesWithFilter", { "filters": FinalFilterFormat, "formRefId": formId, "skip": skipEntries, "limit": entriesLimit })

        if (getALlEntriesWithFilter.status === 200) {
            console.log(getALlEntriesWithFilter.data)
            setTotalEntriesCount(getALlEntriesWithFilter.data.total)
            setAllEntries(getALlEntriesWithFilter.data.limitedData)
        } else {
            setAllEntries([])
            console.log(getALlEntriesWithFilter.data)
        }
    }

    const resetFilters = async (state) => {

        if (state) {
            const allFiltersInput = document.getElementsByClassName("filtersField")
            for (let i = 0; i < allFiltersInput.length; i++) {
                allFiltersInput[i].value = ""
            }

            const allFiltersFrame = document.getElementsByClassName("searchFilters")
            for (let i = 0; i < allFiltersFrame.length; i++) {
                allFiltersFrame[i].style.opacity = "0"
                allFiltersFrame[i].style.transitionDelay = `${(onlyAllowed.length * 0.1) - (0.1 * i)}s`
            }

            setTimeout(async () => {
                if (formId) {
                    let FinalFilterFormat = {};
                    FinalFilterFormat["formRefId"] = formId

                    const query = {
                        "filters": FinalFilterFormat,
                        "formRefId": formId,
                        "skip": 0,
                        "limit": entriesLimit,
                    }
                    console.log(query)

                    getLimitedEntries(query)
                }
                setFilterState(!state)
            }, (allFiltersInput.length * 0.1) * 1000)
        } else {
            const allFiltersInput = document.getElementsByClassName("filtersField")
            for (let i = 0; i < allFiltersInput.length; i++) {
                allFiltersInput[i].value = ""
            }

            const allFiltersFrame = document.getElementsByClassName("searchFilters")
            for (let i = 0; i < allFiltersFrame.length; i++) {
                allFiltersFrame[i].style.opacity = "1"
                allFiltersFrame[i].style.transitionDelay = `${0.1 * i}s`
            }

            setTimeout(() => {
                // getAllForms()
                setFilterState(!state)
            }, (allFiltersInput.length * 0.1) * 1000)
        }
    }

    const setDataToYGEdits = async (entry) => {

        const getFormStructure = await axios.post(serverURL + "/forms/getForm", { "formRefId": entry.formRefId })
        if (getFormStructure.status === 200) {
            // console.log(getFormStructure.data)
            // console.log(Object.keys(entry.submittedData))
            setFormStructure(getFormStructure.data)
            setCurrentYGEditData(entry)
            setShowEditYGDetails(true);
        } else {

        }


    }

    const kardeSaveIsko = async (dataSets) => {
        const loadingButton = document.getElementById("updateUserDetailsButton");


        loadingButton.disabled = true
        loadingButton.innerHTML = `<div class="spinner-border spinner-border-sm text-light" role="status">
                                        <span class="sr-only"></span>
                                    </div>`

        const allData = document.getElementsByClassName("dataGetFields");
        let fieldValues = []
        for (let i = 0; i < allData.length; i++) {

            let type = allData[i].getAttribute("data-type")
            let name = allData[i].getAttribute("data-name")

            let values = null;

            if (type === "File") {
                const getFiledom = document.getElementById(allData[i].getAttribute("id"))

                // console.log(dataSets.submittedData[name])

                if (getFiledom.files.length < 1) {
                    // console.log(allData[i].value)
                    values = dataSets.submittedData[name]
                } else {
                    const base64File = await toBase64(getFiledom.files[0]);
                    // Create payload
                    const payload = {
                        data: base64File.split(',')[1], // Exclude "data:<type>;base64,"
                        fileName: getFiledom.files[0].name,
                        fileType: getFiledom.files[0].type,
                        fileSize: getFiledom.files[0].size,
                    };
                    values = payload
                }

            } else {
                values = allData[i].value
            }

            fieldValues.push({ "type": type, "field": name, "value": values })
        }
        // console.log(fieldValues)



        const query = {
            "filesRef": formId,
            "logs": { "from": user.email, "time": dayjs().valueOf(), "changes": [] },
            "formDataId": dataSets._id,
            "allFields": fieldValues,
        }

        // console.log(query)


        const saveModificationsNow = await axios.post(serverURL + "/forms/updateFormData", query)
        if (saveModificationsNow.status === 200) {
            // console.log(saveModificationsNow.data)

            const getAllEntries = await axios.post(serverURL + "/forms/getAllEntries", { "formRefId": formId })
            if (getAllEntries.status === 200) {
                setAllEntries(
                    getAllEntries.data.filter((entry) => {
                        return entry.submittedData.Status === "Active"
                    })
                )
            } else {
                console.log(getAllEntries.data)
            }

            setShowEditYGDetails(false)
            setCurrentYGEditData(null)
            setPuchLiyaBhaiSaveKeLiye(false)
            loadingButton.disabled = false
            loadingButton.innerHTML = "Ok"
        } else {
            console.log(saveModificationsNow.data)
            loadingButton.disabled = false
            loadingButton.innerHTML = "Ok"
        }

    }

    const prepareFileUploadSystem = async (allData, innerKeyData, data) => {
        const fileStorageReference = allData["submittedData"][innerKeyData].refId;
        const getFileData = await axios.post(serverURL + "/fileStorage/getSingleFile", { "refId": fileStorageReference })
        if (getFileData.status === 200) {
            // console.log(getFileData.data.files[0])
            setViewFormContent(
                <>
                    <form action="" className='d-flex flex-column align-items-center  w-100'>

                        <div id="filePreviewSection" className='w-100'>

                            {
                                updatedFileSelection ?
                                    getFileData.data.files[0].data ?
                                        <PDFViewer base64Data={updatedFileSelection.data} />
                                        :
                                        <CustomSpinner size={1}/>
                                    :
                                    getFileData.data.files[0].data ?
                                        <PDFViewer base64Data={getFileData.data.files[0].data} />
                                        :
                                        <CustomSpinner size={1}/>
                            }
                        </div>
                        {/* <div className="alert alert-info py-2">{JSON.stringify(allData["submittedData"][innerKeyData])}</div> */}

                        <div className='d-flex align-items-center justify-content-center w-100 gap-3 mt-4'>
                            <label htmlFor={`${data.options[0].id}_view`} className='btn btn-sm btn-success w-100 rounded-pill' style={{ maxWidth: "120px" }}>
                                Replace
                            </label>
                            <button type='button' onClick={() => { setShowFileUpdateModal(false) }} className='btn btn-sm btn-secondary w-100 rounded-pill' style={{ maxWidth: "120px" }}>Ok</button>
                        </div>
                    </form>
                </>
            )

        } else {
            console.log(getFileData.data)
            setViewFormContent(<>
                {
                    JSON.stringify(getFileData.data)
                }
            </>)
        }

        setShowFileUpdateModal(true)
    }

    useEffect(() => {
        // console.log(searchFilters)
    }, [searchFilters])

    const toBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    const getLimitedEntries = async (query) => {
        const getAllEntries = await axios.post(serverURL + "/forms/getLimitedEntries", query)
        if (getAllEntries.status === 200) {
            setTotalEntriesCount(getAllEntries.data.total)
            setAllEntries(getAllEntries.data.limitedData)
        } else {
            console.log(getAllEntries.data)
        }
    }

    useEffect(() => {

        if (formId) {
            const query = {
                "formId": formId,
                "skip": skipEntries,
                "limit": entriesLimit,
            }
            // console.log(query)

            getLimitedEntries(query)
        }


    }, [formId, skipEntries, entriesLimit])

    useEffect(() => {
        getAllForms()
    }, [])
    return (
        <>
            <div className="transback h-100 overflow-auto p-3 d-flex flex-column">
                <button className='btn text-secondary rounded-pill px-3 py-1 d-flex d-lg-none d-xl-none d-xxl-none align-items-center gap-2' onClick={() => { setShowSideOverlay(true) }}>
                    <MenuIcon />
                </button>
                <div className="headerUserDetails py-1 mb-3 border-0 d-flex justify-content-between">
                    <span>Yes Family</span>
                    <div className='d-flex gap-2 align-items-center justify-content-center text-dark px-2' style={{ cursor: "pointer" }} title={"Name: " + user.name + "\nEmail: " + user.email}>
                        <i className='fa fa-user'></i>
                        <span>{user.name}</span>
                    </div>
                </div>
                <div className='w-100 h-100 overflow-auto'>
                    {
                        !loadingEntries ?
                            <>
                                <table className='table table-yesgermany table-hover table-striped mb-0' style={{ border: "none", borderColor: "transparent" }}>
                                    <thead className=''>
                                        <tr valign="middle" align="center">
                                            <th className='p-1 m-0' style={{ background: "none" }}>
                                                <button type='reset' className='rounded-circle w-100 border-0' style={{ aspectRatio: "1/1" }} onClick={() => { resetFilters(filterState) }}>
                                                    {
                                                        filterState ?
                                                            <ClearIcon style={{ fontSize: "1rem" }} />
                                                            :
                                                            <FilterListIcon style={{ fontSize: "1rem" }} />
                                                    }
                                                </button>
                                            </th>
                                            {
                                                onlyAllowed.map((namesOfColumn, key) => {
                                                    return (
                                                        <th key={key} className='p-1 m-0' style={{ background: "none" }}>
                                                            <div className="d-flex align-items-center searchFilters gap-2 rounded" title={`Search by ${namesOfColumn}`} style={{ transitionDelay: `${0.1 * key}s` }}>
                                                                <span>
                                                                    <i className='fa fa-search'></i>
                                                                </span>
                                                                <input type="search" placeholder={namesOfColumn} className='p-0 noExist text-center w-100 filtersField' id={`filter_${namesOfColumn}`} onInput={(e) => { addFilters(namesOfColumn, e.target.value) }} />
                                                            </div>
                                                        </th>
                                                    )
                                                })
                                            }
                                        </tr>
                                        <tr>
                                            <th colSpan={onlyAllowed.length + 1} className='py-0' style={{ background: "none" }} ></th>
                                        </tr>
                                    </thead>
                                    <thead className='table-dark sticky-top'>
                                        <tr valign="middle" align="center">
                                            <th>#{totalEntriesCount}</th>
                                            {
                                                onlyAllowed.map((namesOfColumn, key) => {
                                                    return <th key={key} className='text-nowrap'>{namesOfColumn}</th>
                                                })
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            allEntries.length > 0 ?
                                                allEntries.map((entry, key) => {
                                                    return (
                                                        <tr key={key} align="center" onClick={(e) => {
                                                            user.permissions ?
                                                                user.permissions.filter((permission) => { return permission.value.includes("Edit-Employee-Details") }).length > 0 ?
                                                                    setDataToYGEdits(entry)
                                                                    :
                                                                    e.preventDefault()
                                                                :
                                                                e.preventDefault()
                                                        }}>
                                                            <td valign='middle'>{skipEntries + (key + 1)}</td>
                                                            {
                                                                onlyAllowed.map((keyname, key) => {
                                                                    return (
                                                                        <td valign='middle' key={key} className='text-nowrap'>
                                                                            {entry.submittedData[keyname]}
                                                                        </td>
                                                                    )
                                                                })
                                                            }

                                                        </tr>
                                                    )
                                                })
                                                :
                                                <tr>
                                                    <td colSpan={onlyAllowed.length + 1}>
                                                        <div className="glassInfo text-start">No Records for now</div>
                                                    </td>
                                                </tr>
                                        }
                                    </tbody>
                                </table>
                            </>
                            :
                            <div className='w-100 h-100 d-flex flex-column justify-content-center align-items-center gap-2'>
                                <CustomSpinner size={1}/>
                                <span className='text-light fs-6'>Loading Records</span>
                            </div>
                    }
                </div>
                <div className='w-100 mt-2 overflow-hidden customBackgroundFilter rounded'>
                    {
                        !loadingEntries ?
                            <div className='w-100 d-flex h-100'>
                                <button className='border rounded-0 px-2 py-0 text-center' onClick={(e) => { setSkipEntries(0) }} ><FirstPageIcon className='p-0 d-flex align-items-center' style={{ fontSize: "1.1rem" }} /></button>
                                <button className='border rounded-0 px-2 py-0 text-center' onClick={(e) => { if ((Math.floor(skipEntries + entriesLimit) / entriesLimit) > 1) { setSkipEntries(skipEntries - entriesLimit) } }} ><KeyboardArrowLeftIcon className='p-0 d-flex align-items-center' style={{ fontSize: "1.1rem" }} /></button>
                                {
                                    allEntries.map((data, key) => {
                                        if (key < Math.ceil(totalEntriesCount / entriesLimit)) {
                                            return <button className={`border rounded-0 px-2 py-0 text-center paginationBars ${skipEntries / entriesLimit == key ? "active" : ""}`} key={key} onClick={(e) => { setSkipEntries(entriesLimit * key) }}>{key + 1}</button>
                                        }
                                    })
                                }
                                <div className='w-100 py-3'></div>
                                <button className='border rounded-0 px-2 py-0 text-center' onClick={(e) => { if ((Math.floor(skipEntries + entriesLimit) / entriesLimit) < Math.ceil(totalEntriesCount / entriesLimit)) { setSkipEntries(skipEntries + entriesLimit) } }} ><KeyboardArrowRightIcon className='p-0 d-flex align-items-center' style={{ fontSize: "1.1rem" }} /></button>
                                <button className='border rounded-0 px-2 py-0 text-center' onClick={(e) => { setSkipEntries(entriesLimit * (Math.ceil(totalEntriesCount / entriesLimit) - 1)) }}><LastPageIcon className='p-0 d-flex align-items-center' style={{ fontSize: "1.1rem" }} /></button>
                            </div>
                            :
                            ""
                    }
                </div>
            </div>



            {/* ########################### ASK SAVE NOW ############################### */}
            <Modal show={puchLiyaBhaiSaveKeLiye} onHide={() => { setPuchLiyaBhaiSaveKeLiye(false) }} centered>
                <Modal.Header>
                    <p className='w-100 text-center display-6 m-0'>
                        Confirmation
                    </p>
                </Modal.Header>
                <Modal.Body className=' alert alert-info m-0 rounded-0'>
                    <p className='text-center w-100 m-0'>
                        Do you want to current changes
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex align-items-center justify-content-center w-100 gap-3'>
                        <button onClick={() => { kardeSaveIsko(currentYGEditData) }} className='btn btn-md btn-success w-100 rounded-pill' id="updateUserDetailsButton" style={{ maxWidth: "120px" }}>Ok</button>
                        <button onClick={() => { setPuchLiyaBhaiSaveKeLiye(false) }} className='btn btn-md btn-secondary w-100 rounded-pill' style={{ maxWidth: "120px" }}>cancel</button>
                    </div>
                </Modal.Footer>
            </Modal>

            {/* ################## ASK DISCARD ############################### */}
            <Modal show={puchLiyaBhai} onHide={() => { setPuchLiyaBhai(false) }} centered>
                <Modal.Header>
                    <p className='w-100 text-center display-6 m-0'>
                        Confirmation
                    </p>
                </Modal.Header>
                <Modal.Body className=' alert alert-danger m-0 rounded-0'>
                    <p className='text-center w-100 m-0'>
                        Are you sure you want to discard the current changes
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex align-items-center justify-content-center w-100'>
                        <button onClick={() => { setShowEditYGDetails(false); setPuchLiyaBhai(false); }} className='btn btn-md btn-secondary w-100 rounded-pill' style={{ maxWidth: "120px" }}>Ok</button>
                    </div>
                </Modal.Footer>
            </Modal>


            <Modal show={showFileUpdateModal} size='lg' onHide={() => { setShowFileUpdateModal(false) }} centered>
                <Modal.Header>
                    <p className='w-100 text-center fs-4 m-0'>
                        {fieFieldUpdate}
                    </p>
                </Modal.Header>
                <Modal.Body className=' alert alert- m-0 rounded-0'>
                    {
                        viewFormContent
                    }
                </Modal.Body>
                <Modal.Footer>

                </Modal.Footer>
            </Modal>

            <Offcanvas backdrop="static" show={showEditYGDetails} onHide={() => { setShowEditYGDetails(false); }} className='editYgDetailsOffcanvas' placement='end'>
                <Offcanvas.Header className='d-flex align-items-start px-2 px-md-3 px-lg-4 px-xl-4 px-xxl-4'>
                    <div className='d-flex justify-content-between align-items-center w-100'>
                        <Offcanvas.Title>
                            {
                                currentYGEditData ?
                                    <span>
                                        {currentYGEditData.submittedData["Employee Name"]}&nbsp;({currentYGEditData.submittedData["Employee Code"]})
                                    </span>
                                    :
                                    ""
                            }
                        </Offcanvas.Title>
                        <div className='d-flex gap-3'>
                            <button className='btn btn-sm btn-outline-success rounded-pill' style={{ width: "35px", aspectRatio: "1/1" }} onClick={() => { setPuchLiyaBhaiSaveKeLiye(true); }}>
                                <i className='fa fa-check'></i>
                            </button>
                            <button className='btn btn-sm btn-outline-danger rounded-pill' style={{ width: "35px", aspectRatio: "1/1" }} onClick={(e) => { setPuchLiyaBhai(true) }}>
                                <i className='fa fa-times'></i>
                            </button>
                        </div>
                    </div>
                </Offcanvas.Header>
                <Offcanvas.Body className='px-2 px-md-3 px-lg-4 px-xl-4 px-xxl-4'>
                    <form action="" onSubmit={(e) => { }}>
                        {
                            formStructure ?
                                currentYGEditData ?
                                    <div className='w-100 alert p-2 m-0 alert-light shadow-sm'>
                                        <div className="container-fluid">
                                            <div className="row">
                                                {
                                                    Object.keys(currentYGEditData["submittedData"]).map((innerKeyname, keyInner) => {
                                                        if (typeof currentYGEditData["submittedData"][innerKeyname] === 'object' && currentYGEditData["submittedData"][innerKeyname] !== null) {
                                                            return (
                                                                formStructure.fields.form.filter((field) => { return field.label.value.trim().includes(innerKeyname.trim()) }).length > 0 ?
                                                                    <div className="col-12 col-md-6 col-lg-4 mb-2" key={keyInner}>
                                                                        <div className='w-100 text-start'>
                                                                            <span>{innerKeyname} </span>
                                                                            {
                                                                                formStructure.fields.form.filter((field) => { return field.label.value.trim().includes(innerKeyname.trim()) }).length < 1 ?
                                                                                    <input type="text" className='form-control' defaultValue={currentYGEditData["submittedData"][innerKeyname]} />
                                                                                    :
                                                                                    ""
                                                                            }
                                                                            {
                                                                                formStructure.fields.form.filter((field) => { return field.label.value.trim().includes(innerKeyname.trim()) }).map((data, key) => {
                                                                                    return (
                                                                                        <React.Fragment key={key}>
                                                                                            {
                                                                                                data.type.value === "Text" ?
                                                                                                    <input type='text' id={`${data.options[0].id}_view`} defaultValue={JSON.stringify(currentYGEditData["submittedData"][innerKeyname])} required={JSON.parse(data.isRequired.value)} className='form-control dataGetFields' data-type={data.type.value} data-name={innerKeyname} />
                                                                                                    :
                                                                                                    data.type.value === "Phone" ?
                                                                                                        <input type='tel' id={`${data.options[0].id}_view`} defaultValue={JSON.stringify(currentYGEditData["submittedData"][innerKeyname])} required={JSON.parse(data.isRequired.value)} className='form-control dataGetFields' data-type={data.type.value} data-name={innerKeyname} />
                                                                                                        :
                                                                                                        data.type.value === "Number" ?
                                                                                                            <input type='number' id={`${data.options[0].id}_view`} defaultValue={JSON.stringify(currentYGEditData["submittedData"][innerKeyname])} required={JSON.parse(data.isRequired.value)} className='form-control dataGetFields' data-type={data.type.value} data-name={innerKeyname} />
                                                                                                            :
                                                                                                            data.type.value === "Email" ?
                                                                                                                <input type='email' id={`${data.options[0].id}_view`} defaultValue={JSON.stringify(currentYGEditData["submittedData"][innerKeyname])} required={JSON.parse(data.isRequired.value)} className='form-control dataGetFields' data-type={data.type.value} data-name={innerKeyname} />
                                                                                                                :
                                                                                                                data.type.value === "Select" ?
                                                                                                                    <select id={`${data.label.id}_view`} defaultValue={JSON.stringify(currentYGEditData["submittedData"][innerKeyname])} required={JSON.parse(data.isRequired.value)} className='form-control dataGetFields' data-type={data.type.value} data-name={innerKeyname}>
                                                                                                                        {
                                                                                                                            data.options.map((option, key) => {
                                                                                                                                return (
                                                                                                                                    <option key={key} value={option.value} id={`${option.id}_view`}>{option.value}</option>
                                                                                                                                )
                                                                                                                            })
                                                                                                                        }
                                                                                                                    </select>
                                                                                                                    :
                                                                                                                    data.type.value === "Date" ?
                                                                                                                        <input type='date' id={`${data.options[0].id}_view`} defaultValue={JSON.stringify(currentYGEditData["submittedData"][innerKeyname])} required={JSON.parse(data.isRequired.value)} className='form-control dataGetFields' data-type={data.type.value} data-name={innerKeyname} />
                                                                                                                        :
                                                                                                                        data.type.value === "Textarea" ?
                                                                                                                            <textarea id={`${data.options[0].id}_view`} defaultValue={JSON.stringify(currentYGEditData["submittedData"][innerKeyname])} required={JSON.parse(data.isRequired.value)} className='form-control dataGetFields' data-type={data.type.value} data-name={innerKeyname} />
                                                                                                                            :
                                                                                                                            data.type.value === "File" ?
                                                                                                                                // defaultValue={currentYGEditData["submittedData"][innerKeyname]}
                                                                                                                                currentYGEditData["submittedData"][innerKeyname].length > 0 ?
                                                                                                                                    <div className='alert alert-info py-1 d-flex justify-content-between align-items-center'>
                                                                                                                                        <span className='text-nowrap'>{JSON.stringify(currentYGEditData["submittedData"][innerKeyname].length)} Files</span>
                                                                                                                                        <input type='file' id={`${data.options[0].id}_view`} onChange={async (e) => {

                                                                                                                                            const base64File = await toBase64(e.target.files[0]);

                                                                                                                                            // Create payload
                                                                                                                                            const payload = {
                                                                                                                                                data: base64File.split(',')[1], // Exclude "data:<type>;base64,"
                                                                                                                                                fileName: e.target.files[0].name,
                                                                                                                                                fileType: e.target.files[0].type,
                                                                                                                                                fileSize: e.target.files[0].size,
                                                                                                                                            };

                                                                                                                                            // console.log(payload)
                                                                                                                                            setUpdatedFileSelection(payload)

                                                                                                                                            setViewFormContent(
                                                                                                                                                <>
                                                                                                                                                    <form action="" className='d-flex flex-column align-items-center  w-100'>
                                                                                                                                                        <div id="filePreviewSection" className='w-100'>
                                                                                                                                                            {
                                                                                                                                                                payload ?
                                                                                                                                                                    <PDFViewer base64Data={payload.data} />
                                                                                                                                                                    :
                                                                                                                                                                    <CustomSpinner size={1}/>
                                                                                                                                                            }
                                                                                                                                                        </div>
                                                                                                                                                        <div className='d-flex align-items-center justify-content-center w-100 gap-3 mt-4'>
                                                                                                                                                            <label htmlFor={`${data.options[0].id}_view`} className='btn btn-sm btn-success w-100 rounded-pill' style={{ maxWidth: "120px" }}>
                                                                                                                                                                Replace
                                                                                                                                                            </label>
                                                                                                                                                            <button type='button' onClick={() => { setShowFileUpdateModal(false) }} className='btn btn-sm btn-secondary w-100 rounded-pill' style={{ maxWidth: "120px" }}>Ok</button>
                                                                                                                                                        </div>
                                                                                                                                                    </form>
                                                                                                                                                </>
                                                                                                                                            )





                                                                                                                                        }} required={JSON.parse(data.isRequired.value)} className='d-none form-control dataGetFields' data-type={data.type.value} data-name={innerKeyname} />
                                                                                                                                        <div className='d-flex gap-2 justify-content-center'>
                                                                                                                                            <span className='btn btn-sm btn-outline-primary w-100 rounded-pill' style={{ maxWidth: "80px" }} onClick={(e) => {
                                                                                                                                                prepareFileUploadSystem(
                                                                                                                                                    currentYGEditData,
                                                                                                                                                    innerKeyname,
                                                                                                                                                    data
                                                                                                                                                );
                                                                                                                                                setFieFieldUpdate(innerKeyname)
                                                                                                                                            }}>
                                                                                                                                                <i className='fa fa-eye'></i>
                                                                                                                                            </span>
                                                                                                                                        </div>
                                                                                                                                    </div>
                                                                                                                                    :
                                                                                                                                    <input type='file' id={`${data.options[0].id}_view`} required={JSON.parse(data.isRequired.value)} className='form-control dataGetFields' data-type={data.type.value} data-name={innerKeyname} />
                                                                                                                                :
                                                                                                                                data.type.value === "Reset" ?
                                                                                                                                    <button type="reset" id={`${data.type.id}_view`} required={JSON.parse(data.isRequired.value)} className='btn btn-sm btn-secondary rounded-pill w-100' style={{ maxWidth: "120px" }}>{data.label.value}</button>
                                                                                                                                    :
                                                                                                                                    data.type.value === "Submit" ?
                                                                                                                                        <button type="button" id={`${data.type.id}_view`} required={JSON.parse(data.isRequired.value)} className='btn btn-sm btn-success rounded-pill w-100' style={{ maxWidth: "120px" }}>{data.label.value}</button>
                                                                                                                                        :
                                                                                                                                        "Undefined Type"
                                                                                            }
                                                                                        </React.Fragment>
                                                                                    )
                                                                                })

                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    ""
                                                            )
                                                        } else {
                                                            return (
                                                                formStructure.fields.form.filter((field) => { return field.label.value.trim().includes(innerKeyname.trim()) }).length > 0 ?
                                                                    <div className="col-12 col-md-6 col-lg-4 mb-2" key={keyInner}>
                                                                        <div className='w-100 text-start'>
                                                                            <span>{innerKeyname}</span>
                                                                            {
                                                                                formStructure.fields.form.filter((field) => { return field.label.value.trim().includes(innerKeyname.trim()) }).length < 1 ?
                                                                                    <input type="text" className='form-control mb-1 mx-1 dataGetFields' defaultValue={currentYGEditData["submittedData"][innerKeyname]} />
                                                                                    :
                                                                                    ""
                                                                            }
                                                                            {
                                                                                formStructure.fields.form.filter((field) => { return field.label.value.trim().includes(innerKeyname.trim()) }).map((data, key) => {
                                                                                    return (
                                                                                        <React.Fragment key={key}>
                                                                                            {
                                                                                                data.type.value === "Text" ?
                                                                                                    <input type='text' id={`${data.options[0].id}_view`} defaultValue={currentYGEditData["submittedData"][innerKeyname]} required={JSON.parse(data.isRequired.value)} className='form-control dataGetFields' data-type={data.type.value} data-name={innerKeyname} />
                                                                                                    :
                                                                                                    data.type.value === "Phone" ?
                                                                                                        <input type='tel' id={`${data.options[0].id}_view`} defaultValue={currentYGEditData["submittedData"][innerKeyname]} required={JSON.parse(data.isRequired.value)} className='form-control dataGetFields' data-type={data.type.value} data-name={innerKeyname} />
                                                                                                        :
                                                                                                        data.type.value === "Number" ?
                                                                                                            <input type='number' id={`${data.options[0].id}_view`} defaultValue={currentYGEditData["submittedData"][innerKeyname]} required={JSON.parse(data.isRequired.value)} className='form-control dataGetFields' data-type={data.type.value} data-name={innerKeyname} />
                                                                                                            :
                                                                                                            data.type.value === "Email" ?
                                                                                                                <input type='email' id={`${data.options[0].id}_view`} defaultValue={currentYGEditData["submittedData"][innerKeyname]} required={JSON.parse(data.isRequired.value)} className='form-control dataGetFields' data-type={data.type.value} data-name={innerKeyname} />
                                                                                                                :
                                                                                                                data.type.value === "Select" ?
                                                                                                                    <select id={`${data.label.id}_view`} defaultValue={currentYGEditData["submittedData"][innerKeyname]} required={JSON.parse(data.isRequired.value)} className='form-control dataGetFields dataGetFields' data-type={data.type.value} data-name={innerKeyname}>
                                                                                                                        {
                                                                                                                            data.options.map((option, key) => {
                                                                                                                                return (
                                                                                                                                    <option key={key} value={option.value} id={`${option.id}_view`}>{option.value}</option>
                                                                                                                                )
                                                                                                                            })
                                                                                                                        }
                                                                                                                    </select>
                                                                                                                    :
                                                                                                                    data.type.value === "Date" ?
                                                                                                                        <input type='date' id={`${data.options[0].id}_view`} defaultValue={dayjs(currentYGEditData["submittedData"][innerKeyname]).format("YYYY-MM-DD")} required={JSON.parse(data.isRequired.value)} className='form-control dataGetFields' data-type={data.type.value} data-name={innerKeyname} />
                                                                                                                        :
                                                                                                                        data.type.value === "Textarea" ?
                                                                                                                            <textarea id={`${data.options[0].id}_view`} defaultValue={currentYGEditData["submittedData"][innerKeyname]} required={JSON.parse(data.isRequired.value)} className='form-control dataGetFields' data-type={data.type.value} data-name={innerKeyname} />
                                                                                                                            :
                                                                                                                            data.type.value === "File" ?
                                                                                                                                <input type='file' id={`${data.options[0].id}_view`} required={JSON.parse(data.isRequired.value)} className='form-control dataGetFields' data-type={data.type.value} data-name={innerKeyname} />
                                                                                                                                :
                                                                                                                                data.type.value === "Reset" ?
                                                                                                                                    <button type="reset" id={`${data.type.id}_view`} required={JSON.parse(data.isRequired.value)} className='btn btn-sm btn-secondary rounded-pill w-100' style={{ maxWidth: "120px" }}>{data.label.value}</button>
                                                                                                                                    :
                                                                                                                                    data.type.value === "Submit" ?
                                                                                                                                        <button type="button" id={`${data.type.id}_view`} required={JSON.parse(data.isRequired.value)} className='btn btn-sm btn-success rounded-pill w-100' style={{ maxWidth: "120px" }}>{data.label.value}</button>
                                                                                                                                        :
                                                                                                                                        "Undefined Type"
                                                                                            }
                                                                                        </React.Fragment>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    ""
                                                            )
                                                        }
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    ""
                                :
                                ""
                        }
                    </form>
                </Offcanvas.Body>
            </Offcanvas >
        </>
    )
}

export default YesFamily